import type { IPortalUser } from '@experiences/interfaces';

import { get } from '../utility/Requests';

export const userOrganizationInfoUri = '/api/organization/UserOrganizationInfo';

export function getUserOrganizationInfo(token?: string) {
    return get<IPortalUser>(userOrganizationInfoUri, { accessToken: token });
}
